import React from "react";
import { numberToStingWithSpaces } from "../../../../utils/numberDisplayer";
import Table from "../../../../components/molecules/Table/Table";
import StatusBox from "../../../../components/atoms/StatusBox/StatusBox";
import { IconType } from "../../../../assets/JWayIcons";
import { limitString } from "../../../../utils/stringUtils";

export interface ItemSubCredit {
  id: string;
  title?: string;
  description?: string;
  userFullNameRenderer?: () => React.ReactNode;
  date?: string;
  createdDate?: string;
  amount?: number;
  status?: string;
  pinColor?: string;
  withPin?: boolean;
  isChecked?: boolean;
  colorStatus?: {
    backgroundColor?: string;
    color?: string;
    iconType?: IconType;
  };
  onCheck?: () => void;
  onClick?: () => void;
}

export interface SubCreditListViewProps {
  subCreditList: ItemSubCredit[];
  emptyMessage?: string;
  isCheckMode?: boolean;
  noUser?: boolean;
  onSelectAll?: () => void;
  onUnselectAll?: () => void;
  isAllSelected?: boolean;
  isSomeSelected?: boolean;
}

export const SubCreditListViewV2 = ({
  subCreditList,
  emptyMessage,
  isCheckMode,
  noUser,
  onSelectAll,
  onUnselectAll,
  isAllSelected,
  isSomeSelected
}: SubCreditListViewProps) => {
  return (
    <div>
      <Table
        emptyMessage={emptyMessage || 'Aucun sous-crédit'}
        withCheckCase={isCheckMode}
        onSelectAll={onSelectAll}
        onUnselectAll={onUnselectAll}
        isAllSelected={isAllSelected}
        isSomeSelected={isSomeSelected}
        headerTitle={[
          "Description",
          "Créé le",
          "Montant",
          noUser ? undefined : "Utilisateur",
          "Statut"
        ].filter((item) => item !== undefined) as string[]
      }
        bodyData={subCreditList.map((subCredit) => ({
          id: subCredit.id,
          onRowClick: subCredit.onClick,
          onCheck: subCredit.onCheck,
          isChecked: subCredit.isChecked,
          data: [
            () => <span title={subCredit.description || subCredit.title}>{limitString(subCredit.description || subCredit.title || "", 30)}</span>,
            subCredit.createdDate,
            numberToStingWithSpaces(subCredit.amount || 0),
            noUser ? undefined : subCredit.userFullNameRenderer ? subCredit.userFullNameRenderer() : "",
            () => (
              <StatusBox
                color={{
                  background: subCredit.colorStatus?.backgroundColor,
                  text: subCredit.colorStatus?.color,
                }}
               iconType={ subCredit.colorStatus?.iconType}
                size={{
                    height: "20px",
                    font: "0.7rem",
                    width: "100px",
                    lineHeight: "0.8rem"
                }}
              >
                {subCredit.status}
              </StatusBox>
            ),
          ].filter((item) => item !== undefined) as any[],
        }))}
      />
    </div>
  );
};

export default SubCreditListViewV2;

